import loadSlice from "./loadSlice";

export default loadSlice;
